import clsx from 'clsx';
import styles from './JobNodeRelation.module.scss';
import { Icon } from '../../../icon/Icon';

import { Job, JobPipeline } from '../../interfaces/job';
import { jobNodeRelationDataIds } from './data-ids';
import { NodeLogo } from '../../../shared/components/NodeLogo/NodeLogo';
import { Tooltip } from '../../../tooltip/Tooltip';
import { JOB_MODE_ICON_MAP } from '../JobModeIdBadge/constants/job-mode-icons';
import { kebabUnderscoreToDisplayString } from '../../../shared/utils/string/formatter';

interface JobNodeRelationProps {
  pipeline: JobPipeline;
  mode: Job['mode'];
  badgeText?: string;
  className?: string;
}

export function JobNodeRelation({
  pipeline,
  className = '',
  badgeText,
  mode
}: JobNodeRelationProps) {
  const {
    name: destName,
    logoURL: destinationLogoURL,
    darkModeLogoURL: destinationDarkLogoURL
  } = pipeline.destination;

  const {
    name: sourceName,
    logoURL: sourceLogoURL,
    darkModeLogoURL: sourceDarkModeLogoURL
  } = pipeline.source;

  const sourceLogoInfo = {
    logoURL: sourceLogoURL,
    darkModeLogoURL: sourceDarkModeLogoURL
  };

  const destinationLogoInfo = {
    logoURL: destinationLogoURL,
    darkModeLogoURL: destinationDarkLogoURL
  };

  return (
    <div
      className={`${styles.nodeRelationContainer} ${className}`}
      data-id={jobNodeRelationDataIds.container}
    >
      <div className='text-body-1 center-flex-row overflow-hidden w-100'>
        <Tooltip
          title={kebabUnderscoreToDisplayString(mode)}
          dataId={jobNodeRelationDataIds.modeIcon}
        >
          <Icon
            className='mr-1'
            dataId={jobNodeRelationDataIds.modeIcon}
            name={JOB_MODE_ICON_MAP[mode]}
            size={1}
          />
        </Tooltip>

        <span className='mr-2' style={{ width: '32px' }}>
          #{pipeline.seqId}
        </span>

        <div className='center-flex-row mr-2'>
          <Tooltip dataId={jobNodeRelationDataIds.source} title={sourceName}>
            <span>
              <NodeLogo
                size={1}
                roundedBorders
                dataId={jobNodeRelationDataIds.source}
                logoURL={sourceLogoInfo.logoURL}
                darkModeLogoURL={sourceLogoInfo.darkModeLogoURL}
              />
            </span>
          </Tooltip>

          <Icon name='add-arrow-right' className={styles.pipelineConnectionIndicator} />

          <Tooltip dataId={jobNodeRelationDataIds.dest} title={destName}>
            <span>
              <NodeLogo
                logoURL={destinationLogoInfo.logoURL}
                darkModeLogoURL={destinationLogoInfo.darkModeLogoURL}
                size={1}
                roundedBorders
                dataId={jobNodeRelationDataIds.dest}
              />
            </span>
          </Tooltip>
        </div>

        <Tooltip
          dataId={jobNodeRelationDataIds.pipelineNameTooltip}
          title={pipeline.name}
          enableOnTextOverflow
        >
          <span data-id={jobNodeRelationDataIds.pipelineName} className='text-ellipsis'>
            {pipeline.name}
          </span>
        </Tooltip>

        {badgeText ? (
          <div
            data-id={jobNodeRelationDataIds.badge}
            className={clsx(styles.jobBadge, 'text-caption-2')}
          >
            {badgeText}
          </div>
        ) : null}
      </div>
    </div>
  );
}
